import React, { useState } from 'react';
import { Button, IconButton, InputAdornment, Stack, Typography } from '@mui/material';
import logo from '../../../assets/logo/marmin_logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import CustomTextInput from '../../../components/CustomTextInput';
import { loginSuccess } from '../../../api/auth/authSlice';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export const LoginEmailSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email format').required('Email is required'),
  password: Yup.string().required('Password is required'),
});

const LoginForm = ({ redirectTo }) => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    trigger,
    setError,
  } = useForm({
    resolver: yupResolver(LoginEmailSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    authApiClient
      .post('/login', data)
      .then((res) => {
        if (res.data.status?.toLowerCase() === 'otp_required') {
          navigate('/login', { replace: true, state: { email: data.email, stage: 'otp_required' } });
        } else {
          localStorage.setItem('AUTH_TOKEN', res.data.token);
          dispatch(loginSuccess());
          navigate(`${redirectTo}`, { replace: true });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.errors?.password) {
          setError('password', { message: err?.response?.data?.errors?.password });
        } else if (err?.response?.data?.errors?.email) {
          setError('email', { message: err?.response?.data?.errors?.email });
        } else {
          dispatch(
            showSnackbar({
              message: err?.response?.data?.errors?.message || err?.response?.data?.error || 'Something went wrong!',
              severity: 'warning',
            }),
          );
        }
        if (err?.response?.data?.status?.toLowerCase() === 'unverified') {
          navigate('/login', { replace: true, state: { email: data.email, stage: 'verification' } });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Stack sx={{ alignItems: 'center', mb: 4 }}>
        <img src={logo} alt="logo" width="50%" />
      </Stack>
      <Stack spacing={2}>
        <CustomTextInput name="email" label="Email" control={control} errors={errors} />
        <CustomTextInput
          name="password"
          type={showPassword ? 'text' : 'password'}
          label="Password"
          control={control}
          errors={errors}
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        <Typography variant="body2">
          <Link to="/forgot-password" style={{ textDecoration: 'none', paddingBottom: '5rem' }}>
            Forgot Password?
          </Link>
        </Typography>
        <Button id="sign-in" type="button" variant="contained" className="submit" onClick={handleSubmit(onSubmit)}>
          {loading ? 'Logging in...' : 'Sign In'}
        </Button>
        <Typography variant="body2">
          <Link to="/signup" style={{ textDecoration: 'none' }}>
            Don&#39;t have an account? Sign Up
          </Link>
        </Typography>
      </Stack>
    </>
  );
};

export default LoginForm;
